import { ReactNode } from 'react';
import { useLabsByBucketIdQuery } from '../api/queries/labsByBucketId';
import { Link } from 'react-router-dom';

export interface LabFileProps {
  bucketId: number;
  path: string;
  isFolder: boolean;
  render?: (
    labName: string,
    bucketId: number,
    path: string,
    isFolder: boolean
  ) => ReactNode;
}

export function LabFile(props: LabFileProps) {
  const labsQuery = useLabsByBucketIdQuery(props.bucketId);

  const parentPath = props.path.split('/').slice(0, -1).join('/');
  const href = `/files?bucketId=${props.bucketId}&path=${encodeURIComponent(parentPath)}&isFolder=${props.isFolder}`;

  if (!labsQuery.data) {
    return null;
  }

  if (labsQuery.error) {
    return (
      <div className="text-red-500">
        Error loading lab: {(labsQuery.error as Error).message}
      </div>
    );
  }

  if (props.render) {
    return props.render(
      labsQuery.data.name,
      props.bucketId,
      props.path,
      props.isFolder
    );
  } else {
    return (
      <Link to={href} className="underline">
        {labsQuery.data.name}://{props.path}
      </Link>
    );
  }
}
